module.exports = __webpack_public_path__ + "static/media/sidebarbck.38a1af51.jpg";